import '@fortawesome/fontawesome-free/css/all.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import '@progress/kendo-theme-default/dist/all.css';
import $ from 'jquery';
(window as any).$ = $;
(window as any).jQuery = $;
import '@progress/kendo-ui/umd/kendo.all.min.js'
import '@common/kendo-ui-license.js'
import "../Styles/Colors.css";
import "../Styles/KendoUI.css";
import "../Styles/Layout.css";
import "../Styles/Switch.css";

import { createApp, h } from "vue"
import { RouterView } from "vue-router"
import router from './router'
import { sanitizeUrl } from "@braintree/sanitize-url"
import JsonViewer from 'vue-json-viewer'

import '@browser/Browser'
import { appRT } from '@common/AppRT'
import { connect } from "../../../_Workflows/connection"

// Create app ONCE
const app = createApp({
    render: () => h(RouterView)
})

app.use(router)
app.use(JsonViewer)

app.directive('sanitizedHref', {
    mounted(el: HTMLAnchorElement | HTMLLinkElement, binding: any)
    {
        el.href = sanitizeUrl(binding.value)
    },
    updated(el: HTMLAnchorElement | HTMLLinkElement, binding: any)
    {
        el.href = sanitizeUrl(binding.value)
    }
})

// Wait for backend connection, then mount
connect(conn =>
{
    appRT(conn)
    app.mount("#app")
})
